import {
  OFFSET_NTP_TIMESTAMP,
  OFFSET_DECODE_TIME,
  OFFSET_CODEC_TYPE,
  OFFSET_ROTATION,
  OFFSET_MP4_DATA,
} from './constants';

import { BinaryFrame } from './index';

export type Segment = Uint8Array;

// slightly different implementation from vaion- this one uses DataView
export const parseVideoPacket = (frameBuffer: BinaryFrame) => {
  const dataView = new DataView(frameBuffer);

  // Bytes 0-7: 	8 byte NTP source timestamp, Little Endian
  const ntpTimestamp = Number(
    dataView.getBigUint64(OFFSET_NTP_TIMESTAMP, true),
  );

  // Bytes 8-15: 	8 byte Decode timestamp, Little Endian
  const decodeTimestamp = Number(
    dataView.getBigUint64(OFFSET_DECODE_TIME, true),
  );

  // Bytes 16-19: 	4 byte codec tag
  let codecTag = '';
  for (let i = 0; i < 4; i++) {
    codecTag += String.fromCharCode(dataView.getUint8(OFFSET_CODEC_TYPE + i));
  }

  // Bytes 20-23: 	4 byte rotation, Little Endian, in multiples of 90 degrees
  const rotation = Number(dataView.getUint32(OFFSET_ROTATION, true));

  // Bytes 24-: 	Video data
  const segment: Segment = new Uint8Array(frameBuffer, OFFSET_MP4_DATA);

  return new VideoPacket(
    ntpTimestamp,
    decodeTimestamp,
    codecTag,
    segment,
    rotation,
  );
};

// comes directly from vaion
export class VideoPacket {
  constructor(
    public ntp_ts: number,
    public decode_time: number,
    public codec_type: string,
    public segment: Uint8Array,
    public rotation: number,
  ) {}
}
